// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toast-message-container {\n  position: fixed;\n  bottom: 1em;\n  right: 1em;\n  max-width: 300px;\n  width: 100%;\n  z-index: 15;\n}\n", ""]);
// Exports
module.exports = exports;
